import { Card, Button, Container, Row, Col, CardBody, FormGroup, Form, Input, Modal } from 'reactstrap';
import { useContext, useState, useRef } from 'react';
import { Context as AuthContext } from '../../../contexts/AuthContext';
import { toast } from 'react-toastify';
import Documents from '../../../services/Documents';

import { useLocation } from 'react-router-dom';
import { DocumentsStateManager } from './DocumentsStateManager';

type FoldersIdProps = {
  fileId?: string;
  documentsState: DocumentsStateManager;
};

const doSaveFile = async (
  e: React.FormEvent,
  documentsState: DocumentsStateManager,
  schoolId: string,
  documentsFoldersId: string,
  fileName: string,
  position: number,
  attachment: File,
  fileId: string,
  token: string,
) => {
  e.preventDefault();

  const body = {
    schoolId,
    documentsFoldersId: documentsFoldersId,
    name: fileName,
    position,
    fileName: attachment?.name,
  };

  try {
    documentsState.modalFilesShow();
    documentsState.setLoading(true);
    const result = fileId ? await Documents(token).update(fileId, body) : await Documents(token).create(body);

    if (attachment) {
      const formData = new FormData();
      formData.append('attachment', attachment as any);
      await Documents(token).file(result?.data?.id, formData);
    }

    toast.success(`${fileId ? 'Updated' : 'Created'} successfully!`);
    if (result?.data?.id) {
      documentsState.clearData();
      documentsState.doRefresh();
    }
  } catch (e: any) {
    const message = String(e?.response?.data?.message || 'Create error!');
    toast.error(message);
  }
};

const DocumentsForm = ({ documentsState }: FoldersIdProps) => {
  const { token, currentSchool }: any = useContext(AuthContext);
  const { hash } = useLocation();
  const hashFolderId = hash.replace('#', '');
  const schoolId = currentSchool?.value;
  const [isDisabled] = useState(!!documentsState.state.fileModal?.id);

  const position = 100;
  const documentsFoldersId = hashFolderId;
  const [name, setName] = useState(documentsState.state.fileModal?.name || '');

  const fileRef = useRef(null as any);
  const [attachment, setAttachment] = useState<File>({} as File);

  const [pictureUrl] = useState('');

  const fileId = documentsState.state.fileModal?.id;

  const showOpenFileDialog = () => {
    if (isDisabled) {
      return;
    }
    if (fileRef?.current?.click) {
      fileRef.current.click();
    }
  };

  const onChangeFile = (event: any) => {
    event.stopPropagation();
    event.preventDefault();
    const file: File = event.target.files[0];
    setAttachment(file);
  };

  return (
    <Modal
      className="modal-dialog-centered"
      isOpen={documentsState.state.showDocumentsForm}
      toggle={() => documentsState.modalFilesShow()}
    >
      {' '}
      <div className="modal-header">
        <h5 className="modal-title" id="Label">
          New File
        </h5>
        <button
          aria-label="Close"
          className="close"
          data-dismiss="modal"
          type="button"
          onClick={() => documentsState.modalFilesShow()}
        >
          <span aria-hidden={true}>×</span>
        </button>
      </div>
      <div className="modal-body">
        <Container fluid>
          <Form
            onSubmit={async (e) => {
              await doSaveFile(
                e,
                documentsState,
                schoolId,
                documentsFoldersId,
                name,
                position,
                attachment,
                fileId || '',
                token,
              );
            }}
          >
            <Card>
              <CardBody>
                <Row>
                  <Col lg="12">
                    <Row style={{ display: 'grid' }}>
                      <Row>
                        <Col lg="12">
                          <h6 className="heading-small text-muted mb-4">
                            PDF <small style={{ textTransform: 'none' }}></small>
                          </h6>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg="12" style={{ textAlign: 'center' }}>
                          <FormGroup>
                            <input
                              id="img-picture"
                              name="attach"
                              type="file"
                              accept=".pdf"
                              style={{ display: 'none' }}
                              ref={fileRef}
                              disabled={isDisabled}
                              onChange={onChangeFile}
                              required={!fileId}
                            />
                            <img
                              alt={documentsState.state.title}
                              className=""
                              src={pictureUrl ? `${pictureUrl}` : require('../../../assets/img/default.png').default}
                              style={{ width: 135, height: 135, cursor: fileId ? 'not-allowed' : 'pointer' }}
                              onClick={showOpenFileDialog}
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                    </Row>
                  </Col>
                </Row>
                <Row>
                  <Col lg="12">
                    <FormGroup>
                      <label className="form-control-label" htmlFor="input-name">
                        Document Name
                      </label>
                      <Input
                        className="form-control-alternative"
                        id="input-name"
                        placeholder="File Name"
                        type="text"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        required
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col lg="12">
                    <FormGroup>
                      <label className="form-control-label" htmlFor="input-name">
                        File Name
                      </label>
                      <p>{attachment?.name || documentsState.state.fileModal?.fileName}</p>
                    </FormGroup>
                  </Col>
                </Row>
                <Row className="mt-5">
                  <Col md="6 text-center" xs="6">
                    <Button color="primary" type="submit" size="lg" style={{ minWidth: '100px' }}>
                      Save
                    </Button>
                  </Col>
                  <Col md="6 text-center" xs="6">
                    <Button
                      color="secondary"
                      size="lg"
                      style={{ minWidth: '100px' }}
                      onClick={() => {
                        documentsState.modalFilesShow();
                      }}
                    >
                      Cancel
                    </Button>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Form>
        </Container>
      </div>
    </Modal>
  );
};

export default DocumentsForm;
